(function ($) {


    $(document).ready(function () {


        //************************************
        // MAP
        //***********************************


        var MAP_STYLE_1 =
                [
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station.rail",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "saturation": "-100"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    }
                ]
            ;


        function initMap(options) {


            var addressLocations = options.addressLocations;

            var maxZoom = options.maxZoom || 15;

            //console.log(options.element);
            var marker,
                mapOptions = {
                    scrollwheel: false,
                    maxZoom: maxZoom,
                    styles: options.styles,
                    zoom: options.zoom
                },

                map = new google.maps.Map(options.element, mapOptions),

                bounds = new google.maps.LatLngBounds(),

                marker_icon = {
                    path: 'M15.6,0C7,0,0,7,0,15.6S15.7,50,15.7,50s15.6-25.8,15.6-34.4S24.2,0,15.6,0z M15.6,23.1c-4.1,0-7.5-3.3-7.5-7.5c0-4.1,3.3-7.5,7.5-7.5c4.1,0,7.5,3.3,7.5,7.5C23.1,19.7,19.7,23.1,15.6,23.1z',
                    fillColor: options.markerColor,
                    fillOpacity: 1,
                    scale: 0.8,
                    strokeWeight: 0,
                    anchor: new google.maps.Point(20, 20)
                };


            setMarkers(addressLocations);


            function setMarkers(addressLocations) {

                addressLocations.forEach(function (item, i) {

                    var lat = addressLocations[i]['lat'];
                    var lng = addressLocations[i]['lng'];

                    if (lat == null || lng == null) {
                        return;
                    }

                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(lat, lng),
                        map: map,
                        icon: marker_icon
                    });

                    bounds.extend(marker.position);


                });

                map.fitBounds(bounds);

            }

        }


            $('#footer-map').each(function(){
                initMap({
                        addressLocations: [{
                            lat: $(this).data('lat'),
                            lng: $(this).data('lng')
                        }],
                        styles: MAP_STYLE_1,
                        element: $(this)[0],
                        markerColor: '#e8453c'
                    }
                )
            })
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/google-map.es6